import { gql } from '@apollo/client';

const GET_JOB = gql`
  query GetJob($jobId: ID!) {
    jobDetails(id: $jobId) {
      job {
        title
        advertiser {
          name
        }
      }
    }
  }
`;

export default GET_JOB;
